export default __webpack_public_path__ + "static/media/responsive-video.f5a09c28.mp4";